import { checkResponse, hashCode } from "src/components/js/statics1";
import returnMessageClass from "../system/returnMessageClass";

export default class personDontAsksClass {
  isLoaded;
  personId;
  constructor(personId) {
    this.personId = personId;
    this.dontAskHashes = [];
    this.isLoaded = false;

    this.cachedHash = null;

    this.containsHash = this.containsHash.bind(this);
    this.containsText = this.containsText.bind(this);
    this.add = this.add.bind(this);
    this.removeAll = this.removeAll.bind(this);
    this.remove = this.remove.bind(this);
    this.init = this.init.bind(this);
    this.initIfNotLoaded = this.initIfNotLoaded.bind(this);
  }

  async init(token) {
    try {
      const addr = "/api/person/dontAsks/list/" + this.personId;
      const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, {
        method: "GET",
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      const cResponse = await checkResponse(response, "personDontAsksClass.js:init");
      if (!cResponse.success) {
        this.cachedHash = null;
        return false;
      }
      const result = cResponse.data;
      if (result != null || result.length == 0) {
        this.dontAskHashes = [];
        for (let i = 0; i < result.length; i++) {
          this.dontAskHashes.push(result[i].hashValue);
        }
      }
      this.cachedHash = this.hash;
      return true;
    } catch (e) {
      console.log("personDontAsksClass.js: init() failed");
      this.cachedHash = null;
      return false;
    } finally {
      this.isLoaded = true;
    }
  }

  initIfNotLoaded = async (token) => {
    if (!token) return false;
    if (!this.isLoaded) return await this.init(token);
    else return true;
  };

  async containsText(text, token) {
    const hashValue = hashCode(text);
    const c = await this.containsHash(hashValue, token);
    return c;
  }

  async containsHash(hashValue, token) {
    const res = await this.initIfNotLoaded(token);
    if (!res) return false;

    try {
      const s = this.dontAskHashes.includes(hashValue);
      return s;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  async add(dontAskId, token) {
    const returnMessage = new returnMessageClass("personDontAsksClass.js:add");
    const res = await this.initIfNotLoaded(token);
    if (!res) {
      returnMessage.message = "initIfNotLoaded failed";
      return returnMessage;
    }
    this.cachedHash = null;

    const hashValue = hashCode(dontAskId);
    // dont add if already exists
    if (await this.containsHash(hashValue, token)) {
      returnMessage.success = true;
      returnMessage.message = "Valmiiksi olemassa";
      return returnMessage;
    }

    this.dontAskHashes.push(hashValue);
    try {
      const addr = "/api/person/dontAsks/add";
      const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, {
        method: "PUT",
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ personId: this.personId, hashValue: hashValue }),
      });
      if (response.status != 200) {
        returnMessage.success = false;
        returnMessage.message = "Lisäys epäonnistui: " + response.statusText;
        return returnMessage;
      }
      //const data = await fetchResponse.json();
      returnMessage.success = true;
      returnMessage.message = "Lisätty";
      return returnMessage;
    } catch (e) {
      returnMessage.success = false;
      returnMessage.message = "Lisäys epäonnistui";
      returnMessage.error = e;
      console.log(e);
      return returnMessage;
    }
  }

  async remove(dontAskId, token) {
    const res = await this.initIfNotLoaded(token);
    if (!res) return false;
    this.cachedHash = null;

    // dont remove if empty
    if (this.dontAskHashes.length == 0) return false;
    const hashValue = hashCode(dontAskId);
    // remove hashValue from dontAskHashes
    this.dontAskHashes = this.dontAskHashes.filter((item) => item != hashValue);

    const addr = "/api/person/dontAsks/remove/";
    try {
      const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, {
        method: "DELETE",
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ personId: this.personId, dontAskHash: hashValue }),
      });
      const cResponse = await checkResponse(response, "personDontAsksClass.js:remove");
      if (!cResponse.success) return false;
      const result = cResponse.data;
      return result;
    } catch (e) {
      console.log(e);
      return false;
    }
  }
  async removeAll(token) {
    const returnMessage = new returnMessageClass("personDontAsksClass.js:removeAll");
    const personId = this.personId;
    const res = await this.initIfNotLoaded(token);
    if (!res) {
      returnMessage.message = "initIfNotLoaded failed";
      return returnMessage;
    }
    this.cachedHash = null;

    // dont remove if empty
    if (this.dontAskHashes.length == 0) {
      returnMessage.success = true;
      returnMessage.message = "Valmiiksi tyhjä";
      return returnMessage;
    }

    const addr = "/api/person/dontAsks/removeAll/" + personId;
    try {
      const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, {
        method: "DELETE",
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ personId: this.personId }),
      });
      const cResponse = await checkResponse(response, "personDontAsksClass.js:removeAll");
      if (cResponse.success) {
        this.dontAskHashes = [];
        this.cachedHash = this.hash;
        returnMessage.success = true;
        returnMessage.message = "Tyhjennetty";
        returnMessage.data = cResponse.data;
        return returnMessage;
      }
    } catch (e) {
      console.log(e);
      returnMessage.success = false;
      returnMessage.message = "Poisto epäonnistui";
      returnMessage.error = e;
      return returnMessage;
    }
  }

  get hash() {
    if (!this.isLoaded) return null;
    if (this.cachedHash != null) return this.cachedHash;
    let _hash = 0;
    for (let i = 0; i < this.dontAskHashes.length; i++) _hash += this.dontAskHashes[i];
    _hash = _hash + this.personId;
    _hash = _hash % 100000000;
    this.cachedHash = _hash;
    return _hash;
  }
}
